import React, { useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import './MarkdownViewer.css';

interface MarkdownViewerProps {
  title: string;
  content: string;
  onClose: () => void;
}

const MarkdownViewer: React.FC<MarkdownViewerProps> = ({ title, content, onClose }) => {
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [onClose]);

  return (
    <div className="md-viewer-overlay" onClick={onClose}>
      <div className="md-viewer-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="md-viewer-header">
          <span className="md-viewer-title">{title}</span>
          <button className="md-viewer-close" onClick={onClose} aria-label="Close">✕</button>
        </div>
        <div className="md-viewer-body prose prose-sm max-w-none">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
        </div>
      </div>
    </div>
  );
};

export default MarkdownViewer;
